import { render, staticRenderFns } from "./itemImport.vue?vue&type=template&id=80e18f66&scoped=true"
import script from "./itemImport.vue?vue&type=script&lang=js"
export * from "./itemImport.vue?vue&type=script&lang=js"
import style0 from "./itemImport.vue?vue&type=style&index=0&id=80e18f66&prod&lang=scss&scoped=true"
import style1 from "./itemImport.vue?vue&type=style&index=1&id=80e18f66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e18f66",
  null
  
)

export default component.exports